import { stepPetMedicalExpenseLookup as expenseLookup } from './claimCodeMapper';

function mapToParentSection() {
  return {};
}

function mapToQuestionnaire() {
  return [];
}

function mapToExpenses(data) {
  const petMedicalExpenses = mapToPetMedicalExpenses(data);
  return [...petMedicalExpenses];
}

function mapToPetMedicalExpenses(data) {
  if (data.expenseDescriptionOfItems.length < 1) {
    return [];
  }

  const claimCode = expenseLookup.petMedical.claimCode;
  const expenses = [];

  data.expenseDescriptionOfItems.forEach(
    (item) => {
      const expense = mapPetMedicalExpense(item, data, claimCode);
      if (!!expense) {
        expenses.push(expense);
      }
    }
  );

  return expenses;
}

function mapPetMedicalExpense(item, formData, claimCode) {
  return mapExpenseItem(item, formData.dateTripInterrupted, claimCode);
}

function mapExpenseItem(item, itemDate, claimCode) {
  if (!item || !item.amountClaimed || !item.currencyExpensesClaimed) {
    return null;
  }
  return {
    shortDescription: `${item.nameOfProvider}`,
    dateOfExpense: item.dateIncurred,
    clientCost: item.amountClaimed,
    currency: item.currencyExpensesClaimed,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  };
}

export default {
  mapToParentSection,
  mapToQuestionnaire,
  mapToExpenses,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/stepPetMedicalDataMapper.js